module.exports = __webpack_public_path__ + "img/kruiden plukken.fd35399c.jpg";